import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  row: {
    '&:hover': {
      '& $seeDetailsText': {
        opacity: 1,
      },
    },
  },
  seeDetailsText: {
    cursor: 'pointer',
    color: '#072D83',
    opacity: 0,
    fontWeight: 600,
    fontSize: 14,

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    transition: 'all .2s',

    [theme.breakpoints.down('xs')]: {
      position: 'initial',
      opacity: 1,
    },
  },
  seeDetailsIcon: {
    marginLeft: theme.spacing(1),
  },
}));
